import { render, staticRenderFns } from "./PromoScan.vue?vue&type=template&id=54282f1c&scoped=true&"
import script from "./PromoScan.vue?vue&type=script&lang=js&"
export * from "./PromoScan.vue?vue&type=script&lang=js&"
import style0 from "./PromoScan.vue?vue&type=style&index=0&id=54282f1c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54282f1c",
  null
  
)

export default component.exports